const mutations = {
  setUserID(state, userID) {
    state.userID = userID
  },
  setUsername(state, username) {
    state.username = username
  },
  setUserFullname(state, userFullname) {
    state.userFullname = userFullname
  },
  setUserTitle(state, userTitle) {
    state.userTitle = userTitle
  },
  setCompanyID(state, companyID) {
    state.companyID = companyID
  },
  setCanViewEvoAppLeads(state, value) {
    state.canViewEvoAppLeads = value
  },
  setToken(state, token) {
    state.token = token
  },
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions
    if (permissions !== null) {
      localStorage.setItem('permissions', JSON.stringify(permissions))
    } else {
      localStorage.removeItem('permissions')
    }
  },
  SET_PERMISSIONS_LOADED(state, value) {
    state.isPermissionsLoaded = value
  },
  setPasswordChangeToken(state, token) {
    state.passwordChangeToken = token || null
    try {
      if (token) {
        sessionStorage.setItem('passwordChangeToken', token)
      } else {
        sessionStorage.removeItem('passwordChangeToken')
      }
    } catch {
      // sessionStorage unavailable; keep the in-memory value only
    }
  },
  clearAuthData(state) {
    state.userID = null
    state.username = null
    state.userFullname = null
    state.userTitle = null
    state.companyID = null
    state.canViewEvoAppLeads = false
    state.token = ''
    state.permissions = null
    state.isPermissionsLoaded = false
    state.passwordChangeToken = null
    localStorage.removeItem('permissions')
    try {
      sessionStorage.removeItem('passwordChangeToken')
    } catch {
      // ignore
    }
  }
}

export default mutations
